/**
 * 「AIをつなぐ」の絵（components/ConnectPictures.tsx・2026-10-19 design/visual-guides）の英語の文言。en.ts が `...enConnectPics` で取り込む。
 * founder 2026-10-19「文字ばっかりだな。図解とかスクショを使おうよ」。Ops: 確認した人の多くが AI をつながない = いちばん止まっている所。
 * 決まり: 1 段 1 行（絵が説明の本体・文は添えるだけ）。AI の製品名はここ（つなぐの段）にだけ出す（i18n/wording.test.ts の home.step.connect.* と同じ扱い）。
 *   「chat」は閉じた機能（チャット）の言葉として wordsPass.test.ts が止める = 「conversation」「message box」と書く。
 *   押す所の名前（Plugins・Add custom MCP server・Connectors…）はサイトの手順のページ（content/en/claude-and-chatgpt.md）・screens.mjs と同じ言葉。
 *   画面の言葉の正は docs/research/2026-10-11-web-connect-ui.md（変わったらサイトと一緒に直す）
 */
export const enConnectPics = {
  'home.step.connect.pics.label': 'How it goes in',
  'home.step.connect.pics.note': 'Your AI tells you each step. Pictures are illustrations; labels may differ slightly.',
  // 段の 1 行（{ai} = 選んだ AI の名前・{product} = サービス名）
  'home.step.connect.pics.paste': 'Paste the text into {ai}',
  'home.step.connect.pics.chatgptAdd': 'Plugins → + → Add custom MCP server',
  'home.step.connect.pics.claudeAdd': 'Customize → Connectors → Add custom connector',
  'home.step.connect.pics.allow': 'Sign in to {product} and press Allow',
  'home.step.connect.pics.chatgptUse': 'In a new message, type @ and pick {product}',
  'home.step.connect.pics.claudeUse': 'Press + → Connectors and turn {product} on',
  'home.step.connect.pics.runs': '{ai} runs the connect command',
  'home.step.connect.pics.ask': 'Ask it to make something. This page shows Connected',
  // 絵の読み上げ（role="img" の aria-label）。押す所を言葉でも
  'home.step.connect.pics.alt.paste': 'The message box of {ai} with the copied text pasted in, and the send button marked',
  'home.step.connect.pics.alt.chatgptAdd': 'ChatGPT settings: Plugins in the side menu, the + menu open, Add custom MCP server marked',
  'home.step.connect.pics.alt.claudeAdd': 'Claude settings: Customize, Connectors, the + Add menu open, Add custom connector marked',
  'home.step.connect.pics.alt.allow': 'The {product} page "Allow {ai} to use {product}?" with the Allow button marked',
  'home.step.connect.pics.alt.chatgptUse': 'A ChatGPT message box with @ typed and {product} marked in the list',
  'home.step.connect.pics.alt.claudeUse': 'A Claude message box: + menu, Connectors, the {product} switch turned on',
  'home.step.connect.pics.alt.runs': '{ai} running the {product} connect command, with a check mark',
  'home.step.connect.pics.alt.ask': '{ai} with a request typed, and this dashboard step marked Connected'
} as const;
